module.exports = __webpack_public_path__ + "img/xlsxIcon.60450321.svg";